export default __webpack_public_path__ + "static/favicon-black-88d72240b0d57c264fa1b6853830b9d2.png";